var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.state.showSidebar)?_c('div',{staticClass:"SidebarMask",on:{"click":function($event){return _vm.$store.commit('TOGGLE_SIDEBAR', false)}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }